module.exports = __webpack_public_path__ + "static/media/forklift.36a65474.svg";